<template>
  <div class="home-page">
    <!-- 顶部导航 -->
    <header>
      <div class="logo-wrap">
        <img src="/logo.png" alt="叨叨LOGO" class="site-logo">
        <div class="logo-text">叨叨</div>
      </div>
      <div class="nav-right">
        <!-- 未登录显示登录按钮 -->
        <router-link to="/login" class="login-btn" v-if="!isLoggedIn">登录</router-link>

        <!-- 已登录显示用户头像和下拉菜单 -->
        <div class="user-info" v-else-if="userStore && userStore.userInfo">
          <div class="user-avatar-wrapper" @mouseenter="showUserMenu = true" @mouseleave="hideUserMenu">
            <img :src="userStore.userInfo.headImageThumb || ''" alt="头像" class="user-avatar">
            <!-- 下拉菜单 -->
            <div class="user-menu" v-show="showUserMenu">
              <div class="menu-item" @click="logout">退出登录</div>
            </div>
          </div>
          <span class="user-name">{{ userStore.userInfo.nickName || '用户名' }}</span>
        </div>
      </div>
    </header>

    <!-- 首页主内容 -->
    <div class="main">
      <h1>叨叨 · 同步测试工具</h1>
      <router-link to="/home/chat" class="enter-btn" v-if="isLoggedIn">进入聊天</router-link>
      <p class="test-note">本网站用作内部技术性测试，接口功能性研究调试</p>
    </div>

    <!-- 底部备案 合规达标 -->
    <footer>
      <div>
        <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025153659号-1</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      showUserMenu: false
    }
  },
  computed: {
    isLoggedIn() {
      return this.userStore && this.userStore.userInfo && this.userStore.userInfo.id;
    }
  },
  methods: {
    hideUserMenu() {
      // 延迟隐藏，以便用户可以移动到菜单上
      setTimeout(() => {
        this.showUserMenu = false;
      }, 200);
    },
    logout() {
      // 清除登录状态
      if (this.userStore) {
        this.userStore.clear();
      }
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("refreshToken");
      localStorage.setItem("isAutoLogin", false);
      // 跳转到登录页面
      this.$router.push('/login');
    }
  },
  mounted() {
    // 检查登录状态
    if (this.userStore && this.isLoggedIn) {
      this.$router.push('/home/chat');
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 40px;
  border-bottom: 1px solid #f5f5f5;
}

.logo-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.site-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.logo-text {
  font-size: 24px;
  font-weight: 600;
  color: #07c160;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.login-btn {
  padding: 8px 20px;
  border: 1px solid #07c160;
  color: #07c160;
  border-radius: 20px;
  text-decoration: none;
  font-size: 14px;
  transition: 0.3s;
}

.login-btn:hover {
  background-color: #07c160;
  color: #fff;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.user-avatar-wrapper {
  position: relative;
  cursor: pointer;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #eee;
  transition: all 0.2s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 1000;
}

.menu-item {
  padding: 8px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.menu-item:hover {
  background-color: #f5f5f5;
  color: #07c160;
}

.user-name {
  font-size: 14px;
  color: #666;
}

.main {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  text-align: center;
}

.main h1 {
  font-size: 42px;
  color: #222;
  margin-bottom: 16px;
  font-weight: 500;
}

.main p {
  font-size: 16px;
  color: #666;
  max-width: 600px;
  line-height: 1.8;
  margin-bottom: 30px;
}

.test-note {
  font-size: 12px;
  color: #999;
  margin-top: 20px;
  max-width: 500px;
}

.enter-btn {
  padding: 12px 36px;
  background-color: #07c160;
  color: #fff;
  text-decoration: none;
  border-radius: 25px;
  font-size: 16px;
  transition: all 0.3s ease;
  margin-top: 20px;
}

.enter-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

footer {
  text-align: center;
  padding: 20px 0;
  font-size: 13px;
  color: #999;
  border-top: 1px solid #f5f5f5;
}

footer a {
  color: #999;
  text-decoration: none;
}

footer a:hover {
  color: #07c160;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  header {
    padding: 16px 20px;
  }
  
  .main h1 {
    font-size: 32px;
  }
  
  .main p {
    font-size: 14px;
  }
  
  .user-name {
    display: none;
  }
  
  .test-note {
    font-size: 11px;
  }
}
</style>